module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/CrateandBarrel-549771a2195288d5848371238329c7f9.png";